<script setup lang="ts">

import type { RecentlyViewedDoc } from '@/components/Search/types';
import { useI18n } from '@/plugins/i18n';
//props
const props = defineProps({
    docs: { type: Array as () => RecentlyViewedDoc[], default: () => [], required: false }
});

//translations
const i18nInstance: any = useI18n()
const { t } = i18nInstance
</script>

<template>
    <div class="recently-viewed" v-if="docs && docs.length">
        <div class="recently-viewed-container">
        <div class="label">{{ t('recentlyViewed') }}:</div>
        <ul>
            <li v-for="(doc, index) in docs" :key="index">
                <a :href="doc.link" :title="doc.name" class="link">{{ doc.name }}</a>
            </li>
        </ul>
        </div>
    </div>
</template>
<style lang="scss">
    @use './style.scss';
</style>